import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  EstabelecimentoDataService,
  TipoServicoService,
  NichoTermosService,
} from '@nomoh-monorepo/data-access-bardo-administrador';

import { FormFieldComponent } from '@nomoh-monorepo/shared-common-ui';
import { ITipoServico } from '@nomoh-monorepo/shared-types';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-tipo-servico-criar-editar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    FormFieldComponent,
    InputGroupModule,
    TranslateModule,
  ],
  templateUrl: './tipo-servico-criar-editar.component.html',
  styleUrls: ['./tipo-servico-criar-editar.component.scss'],
})
export class TipoServicoCriarEditarComponent implements OnInit {
  //#region Injeção de Dependências
  private fb = inject(FormBuilder);
  private tipoServicoService = inject(TipoServicoService);
  private estabelecimentoDataService = inject(EstabelecimentoDataService);
  $nicho = inject(NichoTermosService).$nicho;

  //#endregion

  //#region Inputs e Outputs
  @Input() tipoServico?: ITipoServico | null;
  @Input() showButton = true;
  @Output() salvo = new EventEmitter<string>();
  @Output() loadingChange = new EventEmitter<boolean>();
  //#endregion

  //#region signals
  $loading = signal<boolean>(false);
  //#endregion
  //#region propriedades

  form: FormGroup = {} as FormGroup;

  get $modoEdicao(): boolean {
    return !!this.tipoServico?.id;
  }
  //#endregion

  ngOnInit(): void {
    this.initForm();
    this.preencherFormulario();
  }

  initForm(): void {
    this.form = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  private preencherFormulario(): void {
    if (this.tipoServico) {
      this.form.patchValue({ nome: this.tipoServico.nome });
    }
  }

  async salvar(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const estabelecimentoId =
      this.estabelecimentoDataService.$estabelecimentoAtual()?.id;
    if (!estabelecimentoId) return;

    this.$loading.set(true);
    this.loadingChange.emit(true);

    try {
      if (this.$modoEdicao && this.tipoServico) {
        await this.tipoServicoService.atualizar(this.tipoServico.id, {
          nome: this.form.value.nome?.trim(),
        });
        this.salvo.emit(this.tipoServico.id);
      } else {
        const novoId = await this.tipoServicoService.criar({
          nome: this.form.value.nome?.trim(),
          estabelecimentoId,
          status: true,
        });
        this.salvo.emit(novoId);
      }
    } catch {
      // erro tratado no service
    } finally {
      this.$loading.set(false);
      this.loadingChange.emit(false);
    }
  }
}
